import React from 'react';
import pick from 'lodash/pick';
import {UserSelector} from 'components/pure/utils/form/UserSelector';
import CoachingPlan, {validate} from 'records/CoachingPlan';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import {IdMap} from '@store/@types/util';
import User from 'records/User';

interface RecipientStepProps {
  users: IdMap<User>;
  directReports: IdMap<User>;
  sessionUser: User;
  model: CoachingPlan;
  onChange: (plan: CoachingPlan) => void;
  loading: boolean;
  showErrors?: boolean;
  frozen?: boolean;
}

export default class RecipientStep extends React.PureComponent<RecipientStepProps> {
  static title = 'Recipient';

  static validate(plan): {recipient?: User} {
    return pick(validate(plan), ['recipient']);
  }

  getPossibleRecipients() {
    const {model, directReports, sessionUser} = this.props;

    // If there are direct reports then use those, unless the user is an Admin
    const allUsers = directReports?.size === 0 || sessionUser.isAdmin();

    const reps = allUsers ? this.props.users : this.props.directReports;
    const planRep = model.recipient.info;
    const coachId = model.coach.id;

    // Ensure rep is in the list, and coach is not
    if (planRep) {
      return reps.set(planRep.id, planRep).delete(coachId);
    } else {
      return reps.delete(coachId);
    }
  }

  render() {
    const {model: coachingPlan, onChange, showErrors, sessionUser, frozen} = this.props;
    const errors = RecipientStep.validate(coachingPlan);
    const possibleRecipients = this.getPossibleRecipients();

    return (
      <div className="coaching-step coaching-plan-wizard-recipient-step">
        <p>Pick the rep who will be receiving the coaching</p>
        <FieldContainer labelType="div" error={showErrors ? errors.recipient?.id : null}>
          <UserSelector
            disabled={frozen}
            value={coachingPlan.recipient.id}
            users={possibleRecipients}
            sessionUser={sessionUser}
            onChange={userId =>
              onChange(
                coachingPlan
                  .setIn(['recipient', 'id'], userId)
                  .setIn(['recipient', 'info'], possibleRecipients.get(userId))
              )
            }
          />
        </FieldContainer>
      </div>
    );
  }
}
